import request from '@/utils/request'

/** 获取用户列表 */
export function getUserList(data) {
  return request({
    url: 'user/SearchUser',
    method: 'post',
    data,
  })
}

/** 获取外协用户列表 */
export function getOutServiceUserList(data) {
  return request({
    url: 'user/SearchOutServiceUserList',
    method: 'post',
    data,
  })
}

/** 添加用户 */
export function addUser(data) {
  return request({
    url: 'user/addUser',
    method: 'post',
    data,
  })
}

/** 编辑用户 */
export function editUser(data) {
  return request({
    url: 'user/editUser',
    method: 'post',
    data,
  })
}

/** 删除用户 */
export function deleteUser(data) {
  return request({
    url: 'user/deleteUser',
    method: 'post',
    data,
  })
}

/** 批量删除用户 */
export function batchDeleteUser(data) {
  return request({
    url: 'user/batchDeleteUser',
    method: 'post',
    data,
  })
}

/** 获取用户信息 详情 */
export function getUserDetail(data) {
  return request({
    url: 'user/getUserDetail',
    method: 'post',
    data,
  })
}

/** 修改密码 */
export function changeUserPassword(data) {
  return request({
    url: 'user/changeUserPassword',
    method: 'post',
    data,
  })
}

/** 数据授权 */
export function userElevatorPermission(data) {
  return request({
    url: 'user/userElevatorPermission',
    method: 'post',
    data,
  })
}

/** 数据授权 */
export function userElevatorPermissionUpdate(data) {
  return request({
    url: 'user/userElevatorPermissionUpdate',
    method: 'post',
    data,
  })
}

/** 获取用户已经授权的数据 */
export function getUserPermissionData(data) {
  return request({
    url: 'user/getUserPermissionData',
    method: 'post',
    data,
  })
}

/** 获取用户列表 */
export function authorizeAllEle(data,userId) {
  return request({
    url: `user/authorizeAllEle/${data}`,
    method: 'post',
    headers: {
      user_id: userId
  },
  })
}

export function save(data) {
  return request({
    url: '/user/wecome/relation/save',
    method: 'post',
    data,
  })
}


// 获取部门成员

export function fetchChildList(data) {
 return request({
   url: `/user/wecome/user/simple/list/${data}/1`,
   method: 'get'
 })
}

// 获取部门列表
export function departmentList() {
  return request({
    url: `/user/wecome/department/list/0`,
    method: 'get'
  })
 }
